export const initCompanyBranchesRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/company-branches",
          name: "company-branches",
          component: () =>
            import("@/pages/manage/company-branches/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
      ];
